module.exports = __webpack_public_path__ + "static/media/forest-bg.c5ba85ad.png";